import { useMutation, useQueryClient } from "@tanstack/react-query"
import { RequestProductsPayload } from "../../../products/types"
import api from "../../http"
import { getApiErrorMessage, toApiError } from "../utils"

export const usePostRequestProducts = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (payload: RequestProductsPayload) => {
            try {
                return (await api.post('/request-products/create', payload)).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao criar requisição de produto');
            }
        },
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['request-products'] }),
        onError: (error) => {
            console.error('Erro ao criar requisição de produto:', getApiErrorMessage(error, 'Erro ao criar requisição de produto'))
        }

    })
}
